import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined'
import { Alert, Card, Space, Tag, Typography } from 'antd'
import { MAX_ENTRIES_FOR_EDIT } from 'features/drilldown/panels/global/bulkEdit/constants'
import { FC } from 'react'

const { Text } = Typography

interface EntriesPreviewProps {
  filteredIds: ReadonlyArray<string>
  totalCount: number
  isWithinEntryLimit: boolean
}

export const EntriesPreview: FC<EntriesPreviewProps> = ({
  filteredIds,
  totalCount,
  isWithinEntryLimit,
}) => (
  <Space orientation='vertical' style={{ width: '100%' }}>
    {!isWithinEntryLimit && (
      <Alert
        title={
          <div>
            <Text strong>Too many entries</Text>
            <br />
            <Text>
              You have {totalCount} entries selected, but bulk edit is limited
              to {MAX_ENTRIES_FOR_EDIT} entries. Please use filters to reduce
              the number of entries.
            </Text>
          </div>
        }
        type='warning'
        showIcon
        icon={<ExclamationCircleOutlined />}
      />
    )}

    <Card
      size='small'
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span>Entries that will be edited</span>{' '}
          <Tag color='green'>
            {totalCount} {totalCount === 1 ? 'entry' : 'entries'}
          </Tag>
        </div>
      }>
      <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
        {filteredIds.map((id) => (
          <Tag color='blue' key={id} style={{ margin: '0.25rem' }}>
            {id}
          </Tag>
        ))}
        {totalCount > filteredIds.length && (
          <Text
            type='secondary'
            style={{ fontSize: '12px', marginLeft: '0.5rem' }}>
            ... and {totalCount - filteredIds.length} more entries
          </Text>
        )}
      </div>
    </Card>
  </Space>
)
